export const FLOW_MODAL_WIDTH = 1140;
export const FLOW_MODAL_PADDING = 20;
export const FLOW_MODAL_SINGLE_COLUMN_CONTENT_MAX_WIDTH = 850;

export const FLOW_MODAL_HEADER_PADDING = FLOW_MODAL_PADDING;
export const FLOW_MODAL_CONTENT_PADDING = FLOW_MODAL_PADDING;
export const FLOW_MODAL_ACTION_BAR_PADDING = FLOW_MODAL_PADDING;
